
import { Language, TranslationKey } from './types';
import { en } from './translations/en';
import { fr } from './translations/fr/index';

// Define the translations
export const translations: Record<Language, Partial<Record<TranslationKey, string>>> = {
  en,
  fr
};
